<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" epub:type="pagebreak" id="pv" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfmf" id="rpref"><a class="xref" href="#/chiguillory0006#pref">Preface</a></p>
<p class="tocpt" id="rpt01"><a class="xref" href="#/chiguillory0007#pt01">Part One: The Formation and Deformation of Literary Study</a></p>
<p class="toc" id="rch01"><a class="xref" href="#/chiguillory0008#ch01"><span class="sm">CHAPTER</span> <span class="sm">1</span>  The Institution of Professions</a></p>
<p class="toc" id="rch02"><a class="xref" href="#/chiguillory0009#ch02"><span class="sm">CHAPTER</span> <span class="sm">2</span>  Professing Criticism</a></p>
<p class="toc" id="rch03"><a class="xref" href="#/chiguillory0010#ch03"><span class="sm">CHAPTER</span> <span class="sm">3</span>  Critique of Critical Criticism</a></p>
<p class="tocpt" id="rpt02"><a class="xref" href="#/chiguillory0011#pt02">Part Two: Organizing Literature: Foundations, Antecedents, Consequences</a></p>
<p class="toc" id="rch04"><a class="xref" href="#/chiguillory0012#ch04"><span class="sm">CHAPTER</span> <span class="sm">4</span>  Monuments and Documents: On the Object of Study in the Humanities</a></p>
<p class="toc" id="rch05"><a class="xref" href="#/chiguillory0013#ch05"><span class="sm">CHAPTER</span> <span class="sm">5</span>  The Postrhetorical Condition</a></p>
<p class="toc" id="rch06"><a class="xref" href="#/chiguillory0014#ch06"><span class="sm">CHAPTER</span> <span class="sm">6</span>  Two Failed Disciplines: Belles Lettres and Philology</a></p>
<p class="toc" id="rch07"><a class="xref" href="#/chiguillory0015#ch07"><span class="sm">CHAPTER</span> <span class="sm">7</span>  The Location of Literature</a></p>
<p class="toc" id="rch08"><a class="xref" href="#/chiguillory0016#ch08"><span class="sm">CHAPTER</span> <span class="sm">8</span>  The Contradictions of Global English</a></p>
<p class="tocpt" id="rpt03"><a class="xref" href="#/chiguillory0017#pt03">Part Three: Professionalization and Its Discontents</a></p>
<p class="toc" id="rch09"><a class="xref" href="#/chiguillory0018#ch09"><span class="sm">CHAPTER</span> <span class="sm">9</span>  On the Permanent Crisis of Graduate Education</a></p>
<p class="toc" id="rch10"><a class="xref" href="#/chiguillory0019#ch10"><span class="sm">CHAPTER</span> <span class="sm">10</span>  Evaluating Scholarship in the Humanities</a></p>
<p class="toc" id="rch11"><a class="xref" href="#/chiguillory0020#ch11"><span class="sm">CHAPTER</span> <span class="sm">11</span>  Composition and the Demand for Writing</a></p>
<p class="toc" id="rch12"><a class="xref" href="#/chiguillory0021#ch12"><span class="sm">CHAPTER</span> <span class="sm">12</span>  The Question of Lay Reading</a></p>
<p class="tocf" id="rch13"><a class="xref" href="#/chiguillory0022#ch13">Conclusion: Ratio Studiorum</a></p>
<p class="tocbmf" id="racknow"><a class="xref" href="#/chiguillory0023#acknow">Acknowledgments</a></p>
<p class="tocbm" id="rindex"><a class="xref" href="#/chiguillory0024#index">Index</a></p>
<p class="tocbm" id="rfn_notes"><a class="xref" href="#/chiguillory0025#fn_notes">Footnotes</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-guillory-0005.vue?72927ab2